import { type Context, createContext } from 'react';

import type { ValueRepresentation } from '../../core/types/scales.js';
import type {
  CategoricalBarData,
  WeakMapCategory,
  WeakMapDimension,
} from '../types/categorical-bar-chart-data.js';

export interface CategoricalChartData {
  categoryMap: WeakMapCategory;
  dimensionMap: WeakMapDimension;
  categoricalData: CategoricalBarData[];
  uniqueDimensions: string[];
  unit?: string;
  valueRepresentation: ValueRepresentation;
}
export const CategoricalBarChartDataContext: Context<CategoricalChartData> =
  createContext<CategoricalChartData>({
    categoryMap: new WeakMap(),
    dimensionMap: new WeakMap(),
    categoricalData: [],
    uniqueDimensions: [],
    valueRepresentation: 'absolute',
  });
